exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dy-dialog-title[data-v-207a8c90] {\n  font-size: 18px;\n  font-weight: 500;\n}\n[data-v-207a8c90] {\n.el-dialog__header {\n    border-bottom: 1px solid rgba(236, 236, 236, 0.89);\n}\n.el-dialog__footer {\n    border-top: 1px solid rgba(236, 236, 236, 0.89);\n}\n.el-dialog__body {\n    padding: 0 20px;\n}\n}\n", ""]);

// exports
